import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApi } from '@mainstage/core-plugin-api';
import { panelCatalogApiRef } from '../api';
import { FeatureRequestStatus } from '@agilelab/plugin-wb-builder-common';

export const useFeatureRequestMutations = () => {
  const panelCatalogApi = useApi(panelCatalogApiRef);
  const queryClient = useQueryClient();

  const updateStatus = useMutation({
    mutationFn: (params: { id: string; status: FeatureRequestStatus }) =>
      panelCatalogApi.updateFeatureRequestStatus(params.id, params.status),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: ['feature-requests', 'list'] });
      queryClient.invalidateQueries({
        queryKey: ['feature-requests', 'detail', variables.id],
      });
    },
  });

  const deleteRequest = useMutation({
    mutationFn: (id: string) => panelCatalogApi.deleteFeatureRequest(id),
    onSuccess: (_data, id) => {
      queryClient.invalidateQueries({ queryKey: ['feature-requests', 'list'] });
      queryClient.invalidateQueries({
        queryKey: ['feature-requests', 'detail', id],
      });
    },
  });

  return { updateStatus, deleteRequest };
};
